module.exports = __webpack_public_path__ + "img/new_20231205_01.404e3956.png";